export default __webpack_public_path__ + "static/media/padlock.0889580c.svg";